import { addClass } from './utilities/dom';
import renderFormElement from './renderFormElement';

const renderForm = (mountNode, els, options) => {
  if (!mountNode) return;

  if (options && options.classNames) {
    const { formClassName } = options.classNames;
    addClass(mountNode, formClassName);
  }

  els.forEach((prop, index) => {
    const element = renderFormElement(prop, index, options);
    mountNode.appendChild(element);
  });
};

export default renderForm;